// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fLhM1K0nuAIKdThUYyzA {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  border: 0.5px solid var(--qa-focusSectionBorderColor);
  cursor: default;
  box-sizing: border-box;
  overflow: hidden;
  background-color: var(--qa-focusSectionQuestionBackgroundColor);
}

.AUox8JYoiNWT5WXu2WTz {
  font-size: var(--qa-focusSectionQuestionFontSize);
  width: 100%;
  padding: 10px;
  font-weight: 600;
  border-bottom: 1px solid var(--qa-focusSectionSeperatorBorderColor);
  background-color: var(--qa-focusSectionQuestionBackgroundColor);
  border-radius: 15px 15px 0 0;
  box-sizing: border-box;
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.Dkay1UuhMj8Hd7hWxJBF {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-left: 10px;
  position: relative;
}

.dCkwrLbu97DbMK23D7cr {
  cursor: pointer;
  font-size: 18px;
  color: var(--qa-thumbsColor);
}

.qVj2R7sRV6KnbfvUzGL2:hover {
  transform: rotate(-5deg) translateY(2px);
  transition: transform 0.3s ease;
}

.iXC0LlCUDicH3z9rG7zZ:hover {
  transform: rotate(-5deg) translateY(-2px);
  transition: transform 0.3s ease;
}

.yR0JiPrp_hHkpnGT9Y8y {
  font-size: var(--qa-focusSectionAnswerFontSize);
  width: 100%;
  position: relative;
  padding: 10px 10px 5px 10px;
  border-radius: 0 0 12px 12px;
  background-color: var(--qa-focusSectionAnswerBackgroundColor);
  text-align: left;
  box-sizing: border-box;
  max-height: 300px;
  overflow-y: auto;
}

.yR0JiPrp_hHkpnGT9Y8y p {
  margin: 0;
  line-height: 1.5em;
  font-size: var(--qa-focusSectionAnswerFontSize);
}

.LP9auHZrDldiMVVXrE9w {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}

.yR0JiPrp_hHkpnGT9Y8y ul {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: var(--qa-focusSectionAnswerFontSize);
}

.yR0JiPrp_hHkpnGT9Y8y ol {
  list-style-type: decimal;
  padding-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: var(--qa-focusSectionAnswerFontSize);
}

.yR0JiPrp_hHkpnGT9Y8y li {
  margin-bottom: 10px;
  font-size: var(--qa-focusSectionAnswerFontSize);
}

.AugoHbEETBS1URAUtZG5 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  font-size: var(--qa-navKeywordButtonFontSize);
  color: #adadad;
  margin-top: 5px;
  box-sizing: border-box;
  position: relative;
}

.hybhaZS1KiTVLxKZXt3O {
  font-size: var(--qa-focusSectionQuestionFontSize);
  flex-grow: 1;
  text-align: left;
}

.X3VdFkC7NUnrr_Nlsdnt {
  font-size: 10px;
}

.l4KDhdkCc7UlPWy2nazg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  gap: 4px;
}

.l4KDhdkCc7UlPWy2nazg p {
  font-size: 12px;
}


.zEmPhflwNWXpbcBv_Oki {
  font-size: 12px;
}

.alNB4hvXuszFYPf7bxZT {
  font-size: 14px;
}

.RzTVlOrW1F9OWWldK4QE {
  position: absolute;
  bottom: 15px;
  left: 65px;
  background-color: var(--qa-disclaimerPopupBackgroundColor);
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 200px;
  z-index: 1000;
  margin-bottom: 10px;
  font-size: 10px;
  color: var(--qa-disclaimerPopupTextColor);
  transform-origin: bottom left;
  animation: zdgQFjqM_T8_xG62bP4D 0.2s ease-out forwards;
}

@media (max-width: 768px) {
  .yR0JiPrp_hHkpnGT9Y8y {
    padding: 10px;
  }

  .dCkwrLbu97DbMK23D7cr {
    font-size: 16px;
  }

  .AugoHbEETBS1URAUtZG5 {
    font-size: 8px;
  }

  .RzTVlOrW1F9OWWldK4QE {
    max-width: 150px;
  }
}

.yBaYiLKFpj4W23HxCu8O {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}
.HqnC3z6Lr9k97zCiT0On {
  --ballcolor: #d0d0d0;
  --shadow: 0px 0 #ffffff00;
  --shadowcolor: #ffffff00;
  width: 10px;
  height: 10px;
  left: -120px;
  border-radius: 50%;
  position: relative;
  color: var(--ballcolor);
  animation: PePHm7eaRbKN81X9nm7h 2s linear infinite;
}

@keyframes PePHm7eaRbKN81X9nm7h {
  
  0% {
    box-shadow: var(--shadow),
        var(--shadow),
        var(--shadow),
        var(--shadow);
  }

  12% {
    box-shadow: 100px 0 var(--ballcolor),
        var(--shadow),
        var(--shadow), 
        var(--shadow);
  }

  25% {
    box-shadow: 110px 0 var(--ballcolor),
        100px 0 var(--ballcolor),
        var(--shadow), 
        var(--shadow);
  }

  36% {
    box-shadow: 120px 0 var(--ballcolor), 
        110px 0 var(--ballcolor), 
        100px 0 var(--ballcolor), 
         var(--shadow);
  }

  50% {
    box-shadow: 130px 0 var(--ballcolor),
        120px 0 var(--ballcolor),
        110px 0 var(--ballcolor),
        100px 0 var(--ballcolor);
  }

  62% {
    box-shadow: 200px 0 var(--shadowcolor),
         130px 0 var(--ballcolor), 
         120px 0 var(--ballcolor), 
         110px 0 var(--ballcolor);
  }

  75% {
    box-shadow: 200px 0 var(--shadowcolor),
        200px 0 var(--shadowcolor),
        130px 0 var(--ballcolor), 
        120px 0 var(--ballcolor);
  }

  87% {
    box-shadow: 200px 0 var(--shadowcolor), 
        200px 0 var(--shadowcolor), 
        200px 0 var(--shadowcolor), 
        130px 0 var(--ballcolor);
  }

  100% {
    box-shadow: 200px 0 var(--shadowcolor), 
        200px 0 var(--shadowcolor),
        200px 0 var(--shadowcolor),
        200px 0 var(--shadowcolor);
  }
}

@keyframes zdgQFjqM_T8_xG62bP4D {
  0% {
    opacity: 0.2;
    transform: scale(0.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.dwiKdPxrQMPGm8xwzN2v {
  position: absolute;
  right: 0;
  color: var(--qa-thumbsColor);
  font-size: 12px;
  opacity: 0;
  min-width: 35px;
  transform: translateY(0);
  animation: WgP2jJoP2FWbLiXjuCIA 1.5s ease-out forwards;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
}

@keyframes WgP2jJoP2FWbLiXjuCIA {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: translateY(0px);
  }
  80% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.sa6PINNlPR9S2HBkaaBz {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.2s;
  box-shadow: none;
  background: none;
}

.sa6PINNlPR9S2HBkaaBz:not(:disabled):hover {
  opacity: 1;
  transform: scale(1.1);
  box-shadow: none;
  color: inherit;
  background: none;
}

.sa6PINNlPR9S2HBkaaBz:disabled {
  cursor: default;
  opacity: 0.3;
  background: none;
  box-shadow: none;
  border: none;
  /* display: none; */
}

.sa6PINNlPR9S2HBkaaBz:disabled:hover {
  opacity: 0.3;
  background: none;
  box-shadow: none;
  border: none;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./app/components/QuestionWithAnswer/QuestionWithAnswer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;EACrD,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,iDAAiD;EACjD,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mEAAmE;EACnE,+DAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;EAC/C,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,6DAA6D;EAC7D,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,6CAA6C;EAC7C,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,0DAA0D;EAC1D,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,6BAA6B;EAC7B,sDAA4C;AAC9C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kDAA2C;AAC7C;;AAEA;;EAEE;IACE;;;qBAGiB;EACnB;;EAEA;IACE;;;qBAGiB;EACnB;;EAEA;IACE;;;qBAGiB;EACnB;;EAEA;IACE;;;sBAGkB;EACpB;;EAEA;IACE;;;gCAG4B;EAC9B;;EAEA;IACE;;;iCAG6B;EAC/B;;EAEA;IACE;;;gCAG4B;EAC9B;;EAEA;IACE;;;gCAG4B;EAC9B;;EAEA;IACE;;;kCAG8B;EAChC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,sDAAmD;EACnD,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-radius: 10px;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n  border: 0.5px solid var(--qa-focusSectionBorderColor);\n  cursor: default;\n  box-sizing: border-box;\n  overflow: hidden;\n  background-color: var(--qa-focusSectionQuestionBackgroundColor);\n}\n\n.questionContainer {\n  font-size: var(--qa-focusSectionQuestionFontSize);\n  width: 100%;\n  padding: 10px;\n  font-weight: 600;\n  border-bottom: 1px solid var(--qa-focusSectionSeperatorBorderColor);\n  background-color: var(--qa-focusSectionQuestionBackgroundColor);\n  border-radius: 15px 15px 0 0;\n  box-sizing: border-box;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-left: 10px;\n  position: relative;\n}\n\n.feedbackButton {\n  cursor: pointer;\n  font-size: 18px;\n  color: var(--qa-thumbsColor);\n}\n\n.feedbackButtonDown:hover {\n  transform: rotate(-5deg) translateY(2px);\n  transition: transform 0.3s ease;\n}\n\n.feedbackButtonUp:hover {\n  transform: rotate(-5deg) translateY(-2px);\n  transition: transform 0.3s ease;\n}\n\n.answerText {\n  font-size: var(--qa-focusSectionAnswerFontSize);\n  width: 100%;\n  position: relative;\n  padding: 10px 10px 5px 10px;\n  border-radius: 0 0 12px 12px;\n  background-color: var(--qa-focusSectionAnswerBackgroundColor);\n  text-align: left;\n  box-sizing: border-box;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.answerText p {\n  margin: 0;\n  line-height: 1.5em;\n  font-size: var(--qa-focusSectionAnswerFontSize);\n}\n\n.contentWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.answerText ul {\n  list-style-type: disc;\n  padding-left: 20px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: var(--qa-focusSectionAnswerFontSize);\n}\n\n.answerText ol {\n  list-style-type: decimal;\n  padding-left: 20px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: var(--qa-focusSectionAnswerFontSize);\n}\n\n.answerText li {\n  margin-bottom: 10px;\n  font-size: var(--qa-focusSectionAnswerFontSize);\n}\n\n.answerFooter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  font-size: var(--qa-navKeywordButtonFontSize);\n  color: #adadad;\n  margin-top: 5px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.questionText {\n  font-size: var(--qa-focusSectionQuestionFontSize);\n  flex-grow: 1;\n  text-align: left;\n}\n\n.aiGeneratedText {\n  font-size: 10px;\n}\n\n.leftContent {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  gap: 4px;\n}\n\n.leftContent p {\n  font-size: 12px;\n}\n\n\n.answerFooterText {\n  font-size: 12px;\n}\n\n.answerFooterIcon {\n  font-size: 14px;\n}\n\n.popup {\n  position: absolute;\n  bottom: 15px;\n  left: 65px;\n  background-color: var(--qa-disclaimerPopupBackgroundColor);\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-width: 200px;\n  z-index: 1000;\n  margin-bottom: 10px;\n  font-size: 10px;\n  color: var(--qa-disclaimerPopupTextColor);\n  transform-origin: bottom left;\n  animation: popupScale 0.2s ease-out forwards;\n}\n\n@media (max-width: 768px) {\n  .answerText {\n    padding: 10px;\n  }\n\n  .feedbackButton {\n    font-size: 16px;\n  }\n\n  .answerFooter {\n    font-size: 8px;\n  }\n\n  .popup {\n    max-width: 150px;\n  }\n}\n\n.loaderContainer {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  padding: 10px;\n  box-sizing: border-box;\n}\n.loader {\n  --ballcolor: #d0d0d0;\n  --shadow: 0px 0 #ffffff00;\n  --shadowcolor: #ffffff00;\n  width: 10px;\n  height: 10px;\n  left: -120px;\n  border-radius: 50%;\n  position: relative;\n  color: var(--ballcolor);\n  animation: shadowRolling 2s linear infinite;\n}\n\n@keyframes shadowRolling {\n  \n  0% {\n    box-shadow: var(--shadow),\n        var(--shadow),\n        var(--shadow),\n        var(--shadow);\n  }\n\n  12% {\n    box-shadow: 100px 0 var(--ballcolor),\n        var(--shadow),\n        var(--shadow), \n        var(--shadow);\n  }\n\n  25% {\n    box-shadow: 110px 0 var(--ballcolor),\n        100px 0 var(--ballcolor),\n        var(--shadow), \n        var(--shadow);\n  }\n\n  36% {\n    box-shadow: 120px 0 var(--ballcolor), \n        110px 0 var(--ballcolor), \n        100px 0 var(--ballcolor), \n         var(--shadow);\n  }\n\n  50% {\n    box-shadow: 130px 0 var(--ballcolor),\n        120px 0 var(--ballcolor),\n        110px 0 var(--ballcolor),\n        100px 0 var(--ballcolor);\n  }\n\n  62% {\n    box-shadow: 200px 0 var(--shadowcolor),\n         130px 0 var(--ballcolor), \n         120px 0 var(--ballcolor), \n         110px 0 var(--ballcolor);\n  }\n\n  75% {\n    box-shadow: 200px 0 var(--shadowcolor),\n        200px 0 var(--shadowcolor),\n        130px 0 var(--ballcolor), \n        120px 0 var(--ballcolor);\n  }\n\n  87% {\n    box-shadow: 200px 0 var(--shadowcolor), \n        200px 0 var(--shadowcolor), \n        200px 0 var(--shadowcolor), \n        130px 0 var(--ballcolor);\n  }\n\n  100% {\n    box-shadow: 200px 0 var(--shadowcolor), \n        200px 0 var(--shadowcolor),\n        200px 0 var(--shadowcolor),\n        200px 0 var(--shadowcolor);\n  }\n}\n\n@keyframes popupScale {\n  0% {\n    opacity: 0.2;\n    transform: scale(0.2);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.thankYouMessage {\n  position: absolute;\n  right: 0;\n  color: var(--qa-thumbsColor);\n  font-size: 12px;\n  opacity: 0;\n  min-width: 35px;\n  transform: translateY(0);\n  animation: thankYouAnimation 1.5s ease-out forwards;\n  writing-mode: horizontal-tb;\n  text-orientation: mixed;\n}\n\n@keyframes thankYouAnimation {\n  0% {\n    opacity: 0;\n    transform: translateY(0);\n  }\n  20% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n  80% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n}\n\n.navButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: inherit;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  box-shadow: none;\n  background: none;\n}\n\n.navButton:not(:disabled):hover {\n  opacity: 1;\n  transform: scale(1.1);\n  box-shadow: none;\n  color: inherit;\n  background: none;\n}\n\n.navButton:disabled {\n  cursor: default;\n  opacity: 0.3;\n  background: none;\n  box-shadow: none;\n  border: none;\n  /* display: none; */\n}\n\n.navButton:disabled:hover {\n  opacity: 0.3;\n  background: none;\n  box-shadow: none;\n  border: none;\n  color: inherit;\n}"],"sourceRoot":""}]);
// Exports
export var container = `fLhM1K0nuAIKdThUYyzA`;
export var questionContainer = `AUox8JYoiNWT5WXu2WTz`;
export var feedbackContainer = `Dkay1UuhMj8Hd7hWxJBF`;
export var feedbackButton = `dCkwrLbu97DbMK23D7cr`;
export var feedbackButtonDown = `qVj2R7sRV6KnbfvUzGL2`;
export var feedbackButtonUp = `iXC0LlCUDicH3z9rG7zZ`;
export var answerText = `yR0JiPrp_hHkpnGT9Y8y`;
export var contentWrapper = `LP9auHZrDldiMVVXrE9w`;
export var answerFooter = `AugoHbEETBS1URAUtZG5`;
export var questionText = `hybhaZS1KiTVLxKZXt3O`;
export var aiGeneratedText = `X3VdFkC7NUnrr_Nlsdnt`;
export var leftContent = `l4KDhdkCc7UlPWy2nazg`;
export var answerFooterText = `zEmPhflwNWXpbcBv_Oki`;
export var answerFooterIcon = `alNB4hvXuszFYPf7bxZT`;
export var popup = `RzTVlOrW1F9OWWldK4QE`;
export var popupScale = `zdgQFjqM_T8_xG62bP4D`;
export var loaderContainer = `yBaYiLKFpj4W23HxCu8O`;
export var loader = `HqnC3z6Lr9k97zCiT0On`;
export var shadowRolling = `PePHm7eaRbKN81X9nm7h`;
export var thankYouMessage = `dwiKdPxrQMPGm8xwzN2v`;
export var thankYouAnimation = `WgP2jJoP2FWbLiXjuCIA`;
export var navButton = `sa6PINNlPR9S2HBkaaBz`;
export default ___CSS_LOADER_EXPORT___;
